import React from 'react';
import { FilterMultiSelect } from '@/app/common/filters/types/multiSelect/FilterMultiSelect.tsx';
import { MealPlanOptionComponent } from '@/app/common/filters/types/shared/Custom/MealPlanOptionComponent.tsx';
import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';

const mealPlanOptionCreators = {
  [FILTER_NAME.MEAL_PLAN]: MealPlanOptionComponent,
};

export const MealPlanFilterMultiSelect = (props: FilterComponentProps) => (
  <FilterMultiSelect {...props} customOptionCreators={mealPlanOptionCreators} />
);
